<div class="dropdown">
  @if (user && user.email && user.email.length > 0) {
    <div class="nav-settings" data-bs-toggle="dropdown" data-cy="user-box">
      <div class="flex-gap-10 align-items-center">
        <div>
          <div class="icon-circle">
            <span class="icon">
              <i class="far fa-user"></i>
            </span>
          </div>
        </div>
        <div class="user-email">
          {{ user.email }}
        </div>
        <div style="width: 14px">
          <i [ngClass]="{ hide: isHidden }" class="far fa-chevron-down"></i>
          <i [ngClass]="{ hide: !isHidden }" class="far fa-times"></i>
        </div>
      </div>
    </div>
  }
  @if (user && user.email && user.email.length > 0) {
    <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
      <div class="dropdown-item">
        <btn
          [icon]="'far-user'"
          [routerLink]="['/my', 'profile']"
          [label]="'user.profile'"
          [title]="'user.profile' | translate"
          [classes]="['btn-third', 'me-3']"
          [dataCyAttribute]="'profile'"
        ></btn>
        <btn
          [icon]="'far-lock'"
          (onEvent)="logout()"
          [label]="'user.logout'"
          [title]="'user.logout' | translate"
          [classes]="['btn-third', 'me-3']"
          [dataCyAttribute]="'sign-out'"
        ></btn>
        <!-- Add another account -->
        <btn
          [icon]="'far-plus'"
          (onEvent)="openAddAccount()"
          [label]="'user.add-account'"
          [title]="'user.add-account' | translate"
          [classes]="['btn-third']"
          [dataCyAttribute]="'add-account'"
        ></btn>
        <!-- Logged-in accounts -->
        @if (sessions.length > 1) {
          <div class="mt-2">
            <div class="session-list-label text-muted small mb-1">{{ 'user.accounts' | translate }}</div>
            @for (session of sessions; track session) {
              <div
                class="session-item"
                [class.session-item--active]="session.id === activeSessionId"
                data-cy="session-item"
              >
                <a
                  class="session-item__clickable"
                  [href]="getOpenSessionUrl(session.id)"
                  target="_blank"
                  rel="noopener"
                  (click)="onSessionItemClick($event, session.id)"
                >
                  <div class="session-item__icon">
                    <i class="far fa-user-circle"></i>
                  </div>
                  <div class="session-item__info">
                    <div class="session-item__email">{{ session.email }}</div>
                    @if (session.company?.name) {
                      <div class="company-name">{{ session.company.name }}</div>
                    }
                  </div>
                  @if (session.clientType === 'stage') {
                    <div class="session-item__badge">stage</div>
                  }
                  @if (session.id === activeSessionId) {
                    <div class="session-item__check">
                      <i class="far fa-check"></i>
                    </div>
                  }
                </a>
                @if (session.id !== activeSessionId) {
                  <div
                    class="session-item__remove"
                    (click)="$event.stopPropagation(); removeSession(session.id)"
                    [title]="'user.remove-account' | translate"
                  >
                    <i class="far fa-times"></i>
                  </div>
                }
              </div>
            }
          </div>
        }
        <div class="version-info">
          <div>{{ 'version' | translate }}: {{ appVersion }}</div>
          <div>{{ 'build.commit' | translate }}: {{ commitShortHash }}</div>
          <div>{{ 'build.branch' | translate }}: {{ branchName }}</div>
          @if (commitDate) {
            <div>{{ 'build.commitDate' | translate }}: {{ commitDate }}</div>
          }
          <div>
            <a
              class="changelog-link"
              [routerLink]="['/changelog']"
              [title]="'changelog.link' | translate"
              data-cy="changelog-link"
            >
              {{ 'changelog.link' | translate }}
            </a>
          </div>
        </div>
      </div>
    </div>
  }
</div>

<app-modal-add-login #addLoginModal (accountAdded)="onAccountAdded($event)"></app-modal-add-login>
